import {
    LEGAL_AUTHORIZATION,
    LEGAL_AUTHORIZATION_SUCCESS,
    LEGAL_AUTHORIZATION_ERROR
} from './actionTypes';

const initialState = {
    isLoading: true,
    legalResponse: null,
    error: null
}

const LegalReducer = (state = initialState, action: any) => {
    const { type, payload } = action;

    switch (type) {
        case LEGAL_AUTHORIZATION:
            return {
                ...state,
            }
        case LEGAL_AUTHORIZATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                legalResponse: payload
            }
        case LEGAL_AUTHORIZATION_ERROR:
            return {
                ...state,
                isLoading: false,
                error: payload
            }
        default:
            return {
                state
            }
    }
}

export default LegalReducer